import type { PropsWithChildren, ReactElement, ReactNode } from 'react';

import Footer from './footer.component';
import Header from './header.component';

interface AuthLayoutProps {
  hero: string;
  nav?: ReactNode;
}

function Hero({ hero }: { hero: string }): ReactElement {
  return (
    <div className="hidden w-[45%] shrink-0 py-6 pr-8 md:block">
      <img alt="" className="size-full rounded-3xl object-cover" src={hero} />
    </div>
  );
}

export function AuthLayout({
  hero,
  nav,
  children,
}: PropsWithChildren<AuthLayoutProps>): ReactElement {
  return (
    <div className="flex min-h-screen md:h-screen md:min-h-0 md:overflow-hidden">
      <div className="flex flex-1 flex-col md:overflow-y-auto">
        <Header nav={nav} />
        {children}
        <Footer />
      </div>
      <Hero hero={hero} />
    </div>
  );
}
